import React, { useState } from 'react'
import { Row, Col } from 'react-flexbox-grid'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'

import { useMutation } from 'components/graphql'
import Button from 'components/Button'
import { TextArea } from 'components/forms'
import { DataTable } from 'components/DataTable'
import { AlertModal, ServiceModal } from 'components/Modal'
import Divider from 'components/Divider'

import cancelBillMutation, { listCancellationReasons } from '../gql/cancelBill'
import { listClosings } from '../gql'


const BillCancel = ({ setBillData, billData, listClosingsVariables }) => {
	const history = useHistory()
	const [t] = useTranslation()
	const [cancelBillError, setCancelBillError] = useState()
	const [cancelModal, setCancelModal] = useState()
	const [reason, setReason] = useState({})

	const [cancelBill] = useMutation(cancelBillMutation, {
		onError: ({ graphQLErrors }) => {
			const errorCode = graphQLErrors?.[0]?.message
			if(errorCode) {
				setCancelBillError(errorCode)
			}
		},
		refetchQueries: [
			{ query: listClosings, variables: listClosingsVariables }
		],
		onCompleted: ({ cancellBill: result }) => {
			history.push(`/abschlusse/belege/${result.closingId}`)
		}
	})

	const handleCancelBill = () => {
		if(!reason.text && !reason.id) {
			return setReason(r => ({
				...r,
				error: t('validators.required')
			}))
		}
		const isNewReason = reason.text !== reason.textOriginal
		cancelBill({
			variables: {
				id: billData.id,
				reasonId: isNewReason ? null : reason.id,
				reasonText: isNewReason ? reason.text : null
			},
			optimisticResponse: {
				__typename: 'Mutation',
				cashAssist: {
					__typename: 'CA_Mutation',
					cancellBill: {
						id: billData.id,
						isCancelled: true,
						closingId: '-1',
						__typename: 'Bill'
					}
				}
			}
		})
		setBillData(oldBillData => ({
			...oldBillData,
			isCancelled: true
		}))
		setCancelModal(false)
	}

	return(
		<>
			<Button
				text={t('closing_section.buttons.cancel_bill')}
				status={billData.isCancelled ? 'inactive' : 'cancelation'}
				onClick={() => setCancelModal(true)}
			/>
			{cancelModal &&
				<ServiceModal
					onClose={() => setCancelModal()}
					onOk={handleCancelBill}
					width={700}
					label={t('closing_section.strings.cancel_bill')}
					keyPressActions={false}
				>
					<Row>
						<Col xs={6}>
							<DataTable
								columns={[{
									Header: t('closing_section.strings.cancel_reason'),
									accessor: 'text'
								}]}
								onRowClick={(table, { original }) => setReason({
									id: original.id,
									text: original.text,
									textOriginal: original.text
								})}
								remoteOptions={{
									query: listCancellationReasons
								}}
							/>
						</Col>
						<Col xs={5}>
							<TextArea
								noForm
								style={{ height: '300px' }}
								value={reason.text}
								error={reason.error}
								onChange={e => setReason(r => ({
									...r,
									text: e.target.value,
									error: null
								}))}
							/>
						</Col>
					</Row>
					<Divider/>
				</ServiceModal>
			}
			{cancelBillError &&
				<AlertModal
					onClose={() => setCancelBillError()}
					text={cancelBillError}
					showBtn
				/>
			}
		</>

	)
}

export default BillCancel